import Component from "../../../core/Component.js";
import {SignUpComponent} from "../components/SignUpComponent.js";

export class PageView extends SignUpComponent {


    render() {
        this.renderLayout();
        this.renderComponents();
        this.mounted();
    }

    renderLayout() {

    }

    renderComponents() {

    }

    getSectionId() {
        return `sectionId`;
    }

    getNextButtonText() {
        return i18next.t(login.next);
    }


}